import * as React from 'react';
import { SVGProps } from 'react';

const IconSmileFilledSizeL = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14 26c6.627 0 12-5.373 12-12S20.627 2 14 2 2 7.373 2 14s5.373 12 12 12Zm-2-16H9v3h3v-3Zm7 0h-3v3h3v-3Zm1.272 6.795c-2.897 4.635-9.647 4.635-12.544 0l2.544-1.59c1.722 2.755 5.734 2.755 7.456 0l2.544 1.59Z"
    />
  </svg>
);
export default IconSmileFilledSizeL;
